import { api } from '../api/client'
import type { Voice, VoiceAccount, VoiceKind, VoiceLibrary, VoiceNoteTestBody, VoiceNoteTestResult } from '../api/client'

/** What the Voices page calls; tests pass fakes. */
export interface VoicesApi {
  library: () => Promise<VoiceLibrary>
  accounts: () => Promise<VoiceAccount[]>
  setVoice: (accountIds: string[], voice: { kind: VoiceKind; id: string } | null) => Promise<VoiceAccount[]>
  previewUrl: (kind: VoiceKind, id: string) => Promise<string>
  /** A voice the Account already uses that is not in your library (someone else's). */
  accountPreviewUrl: (accountId: string, kind: VoiceKind, id: string) => Promise<string>
  clone: (label: string, files: File[]) => Promise<Voice>
  remove: (voiceId: string) => Promise<unknown>
  test: (accountId: string, body: VoiceNoteTestBody) => Promise<VoiceNoteTestResult>
}

export const voicesApi: VoicesApi = {
  library: () => api.getVoiceLibrary(),
  accounts: () => api.getVoiceAccounts(),
  setVoice: (ids, voice) => api.setAccountVoices(ids, voice),
  previewUrl: (kind, id) => api.getLibraryVoicePreviewUrl(kind, id),
  accountPreviewUrl: (accountId, kind, id) => api.getVoicePreviewUrl(accountId, kind, id),
  clone: (label, files) => api.cloneLibraryVoice(label, files),
  remove: (id) => api.deleteLibraryVoice(id),
  test: (accountId, body) => api.testVoiceNote(accountId, body),
}
